// extracted by mini-css-extract-plugin
module.exports = {"container":"info_entry_container__3Came","label":"info_entry_label__laj2x","content":"info_entry_content__3UJNz"};